<template>
  <div class="expired-page">
    <!-- 背景图 -->
    <img src="../assets/authorize/page-bg.png" alt="" class="expired-bg" />
    <!-- 内容区 -->
    <div class="expired-content">
      <!-- 警告图标 -->
      <div class="expired-warning">
        <img src="../assets/authorize/warning.png" alt="警告" />
      </div>

      <!-- 主标题 -->
      <div class="expired-title">您的平台授权已到期</div>

      <!-- 描述文字 -->
      <div class="expired-desc">
        任务下发功能已关闭，设备目前无法启动试验，历史检测数据完整保留，续费后任务下发功能将即时恢复。<br />
        如需紧急恢复检测，请立即续费或联系客服申请临时授权。
      </div>

      <!-- 续费联系框 -->
      <div class="authorize-remaining">
        <img
          src="../assets/authorize/page-remaining-days.png"
          alt=""
          class="remaining-frame"
        />
        <div class="remaining-content">
          <span class="contact-label">联系电话：</span>
          <span class="contact-number">136 1823 0006</span>
          <span class="contact-or">或</span>
          <span class="contact-number">153 1095 6905</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from "vue";
import { apiAuthorize } from "@/api/authorize/api-authorize.js";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const router = useRouter();
const store = useStore();

// rem 自适应 - 独立页面需自行设置根字体大小
const setFontSize = () => {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  if (!screenWidth || !screenHeight) return;

  const screenRatio = screenWidth / screenHeight;
  const screenRatioDesign = 1920 / 1080;

  let fontSize;
  if (screenRatio > screenRatioDesign) {
    fontSize = (screenHeight / 10) * screenRatioDesign;
  } else {
    fontSize = screenWidth / 10;
  }
  document.documentElement.style.fontSize = fontSize.toFixed(5) + "px";
};

let resizeObserver;
let authorizeTimer = null;

// 获取授权信息，若续费成功则跳回主界面
const getAuthorizeInfo = async () => {
  try {
    const res = await apiAuthorize.getEnhancedSystemConfig();
    if (res.data.code === 0) {
      const daysRemaining = res.data.data?.daysRemaining;
      store.commit("engine/setDaysRemaining", daysRemaining);
      if (
        daysRemaining !== null &&
        daysRemaining !== undefined &&
        daysRemaining > 0
      ) {
        router.push({ path: "/" });
      }
    }
  } catch (error) {
    console.error("获取授权信息失败:", error);
  }
};

onMounted(() => {
  setFontSize();
  getAuthorizeInfo();
  // 每分钟轮询一次授权信息
  authorizeTimer = setInterval(getAuthorizeInfo, 60 * 1000);
  const bodyDOM = document.querySelector("body");
  resizeObserver = new ResizeObserver(() => {
    setFontSize();
    window.dispatchEvent(new Event("resize"));
  });
  resizeObserver.observe(bodyDOM);
});

onUnmounted(() => {
  if (resizeObserver) {
    const bodyDOM = document.querySelector("body");
    resizeObserver.unobserve(bodyDOM);
  }
  // 清理授权轮询定时器，防止内存泄漏
  if (authorizeTimer) {
    clearInterval(authorizeTimer);
    authorizeTimer = null;
  }
});
</script>

<style scoped>
.expired-page {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #030409;
  overflow: hidden;
}

.expired-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  z-index: 0;
}

.expired-content {
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.expired-warning {
  margin-bottom: 0.15rem;
}

.expired-warning img {
  width: 1.1rem;
  object-fit: contain;
}

.expired-title {
  margin: 0;
  font-size: 0.4rem;
  color: #fff;
  text-align: center;
  letter-spacing: 0.02rem;
}

.expired-desc {
  margin: 0.15rem 0 0;
  font-size: 0.16rem;
  color: #9fc6ff;
  text-align: center;
  line-height: 1.8;
  max-width: 90%;
}

.authorize-remaining {
  position: relative;
  margin-top: 0.3rem;
  max-width: 80%;
  height: 0.6rem;
  padding: 0 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
}

.remaining-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.remaining-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.05rem;
  font-size: 0.16rem;
}

.contact-label {
  color: #fff;
  white-space: nowrap;
}

.contact-number {
  font-family: "PangMenZhengDao", sans-serif;
  color: #9fc6ff;
  letter-spacing: 0.01rem;
  font-size: 0.2rem;
}

.contact-or {
  color: #fff;
}
</style>
